import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import {
  GetWard,
  GetZone,
  GetCircle,
  GetCirclebyID,
  CreateWardDeatails,
  UpdateWardDetails,
  getWardById,
} from "../../Apis/organizationApi";
import { useForm } from "react-hook-form";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { TableLoader } from "../../Common/ShimmerLoader";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import ExcelJS from "exceljs";
import { handleAlphaNumeric } from "../../../utils/ValidationsHelper";
const OrganizationWard = ({ t }) => {
  const navigate = useNavigate();
  const [lgShow, setLgShow] = useState(false);
  const [wards, setWards] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  const [loadingCircles, setLoadingCircles] = useState(false);
  const [selectedCircle, setSelectedCircle] = useState("");
  // const [status, setStatus] = useState("")
  // const [newWardName,setNewWardName]=useState("");
  const [editWardData, setEditWardData] = useState("");
  const [allCircles, setAllCircles] = useState([]);
  const [allZones, setAllZones] = useState([]);
  const [zones, setZones] = useState([]);
  const [circleFetchError, setCircleFetchError] = useState(null);
  const [editWardId, setEditWardId] = useState(null);
  const [orginalCircles, setOriginalCircle] = useState([]);
  const [circles, setCircles] = useState([]);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const resetRef = useRef(null);
  const [sortConfig, setSortConfig] = useState(null);
  const [originalData, setOriginalData] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [filterOriginalWardData, setFilterOriginalWardData] = useState([]);
  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  const canEdit = localStorage.getItem(`permission`);
  // console.log(canEdit)
  const [formInput, setFormInput] = useState({
    wardId: "",
    wardCode: "",
    wardName: "",
    circleId: "",
    zoneId: "",
    isActive: true,
  });
  const headers = ["zone", "circle", "ward", "wardCode", "status", "actions"];
  const {
    reset,
    formState: { errors },
  } = useForm();
  useEffect(() => {
    fetchDataWard();
    fetchZoneData();
    fetchCircleData();
  }, []);

  useEffect(() => {
    fetchDataWard();
  }, []
  );

  useEffect(() => {
    // Combine sortedData with excelData
    setExcelData(sortedData);
  }, [sortedData]);
  const fetchZoneData = async () => {
    try {
      const response = await GetZone();
      setZones(response);
    } catch (error) {
      console.error("Error fetching zones:", error);
    }
  };

  const fetchCircleData = async () => {
    try {
      const response = await GetCircle();
      setCircles(response);
    } catch (error) {
      console.error("Error fetching circles:", error);
    }
  };

  useEffect(() => {
    fetchDataWard();
  }, []);

  const fetchWardData = async () => {
    try {
      setIsOptionsLoading(true);

      const wardResponse = await GetWard();
      const circleResponse = await GetCircle();
      const zoneResponse = await GetZone();

      const circleNamesDictionary = {};
      circleResponse.forEach(circle => {
        circleNamesDictionary[circle.circleId] = circle.circleName;
      });

      const zoneNamesDictionary = {};
      zoneResponse.forEach(zone => {
        zoneNamesDictionary[zone.zoneId] = zone.zoneName;
      });

      const circleZoneMapping = {};
      circleResponse.forEach(circle => {
        circleZoneMapping[circle.circleId] = circle.zoneId;
      });

      const translatedCircleData = circleResponse.map(circle => ({
        ...circle,
        zone: zoneNamesDictionary[circle.zoneId] || "Unknown",
        circle: `${circle.circleName} [${circle.circleCode}]`,
      }));

      const translatedWardData = wardResponse.map(ward => ({
        ...ward,
        circle: circleNamesDictionary[ward.circleId] || "Unknown",
        zone: zoneNamesDictionary[circleZoneMapping[ward.circleId]] || "Unknown",
        zoneId: circleZoneMapping[ward.circleId], // Include zoneId here
        ward: `${ward.wardName}`,
        status: ward.isActive ? "Active" : "InActive"
      }));

      const sortedRouteData = translatedWardData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setSortedData(sortedRouteData);

      setAllCircles(translatedCircleData);
      setWards(sortedRouteData);
      setOriginalData(sortedRouteData);
      setFilterOriginalWardData(sortedRouteData);
      // Sort the data based on the isActive field
      // const sortedWardData = translatedWardData.sort((a, b) => {
      //   if (a.isActive === b.isActive) {
      //     return 0;
      //   }
      //   return a.isActive ? -1 : 1;
      // });
      setIsOptionsLoading(false);
    } catch (error) {
      console.error("Error fetching wards:", error);
    }
  };

  useEffect(() => {
    fetchAllDataDetails();
    fetchWardData();
  }, []);

  useEffect(() => {
    setFormInput(
      editWardData || {
        // zoneId: "",
        // zoneName: "",
        wardName: "",
        wardId: "",
        isActive: true,
        circleId: "",
      }
    );
  }, [editWardData]);

  useEffect(() => {
    resetRef.current = reset;
  }, [reset]);

  const handleClose = () => {
    setFormSubmitted(false);
    resetFields();
    setLgShow(false);
    setEditWardData(null);
    setFormInput({
      zoneId: "",
      zoneName: "",
      isActive: "",
      circleId: "",
    });
    setEditWardData(null);
  };

  const fetchDataWard = async () => {
    try {
      const circleData = await GetCircle();
      const zoneData = await GetZone();
      // const warddata =await GetWard();
      // Create a dictionary of Zone IDs and Zone Names
      const zoneNamesDictionary = {};
      zoneData.forEach(zone => {
        zoneNamesDictionary[zone.zoneId] = zone.zoneName;
      });

      // Map Zone Names to Circles
      const translatedData = circleData.map(circle => ({
        ...circle,
        zoneName: zoneNamesDictionary[circle.zoneId] || "Unknown",
        //  zoneName: zoneNamesDictionary[circle.zoneId] || "Unknown",
        circleName: `${circle.circleName} [${circle.circleCode}]`,

      }));
      setCircles(translatedData);
      setOriginalCircle(circleData);
   
      // getting zone dropsown active only
      const trueValues = zoneData.filter(item => item.isActive === true)
      setZones(trueValues);
      // getting circle dropsown active only
      // const trueValuesCircle = circleData.filter(item => item.isActive === true)
      setZones(trueValues);
      // setZones(zoneData);
      setIsOptionsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCreateWard = async (e) => {
    e.preventDefault();
    // Destructure formInput for ease of use
    //  const { zoneId, circleId, wardName, wardCode, isActive } = formInput;
    setFormSubmitted(true);

    try {
      // Check if zoneId and circleId are provided
      setIsOptionsLoading(true);
      setTimeout(() => {
        setIsOptionsLoading(false);
      }, 7000);
      // if (!formInput.zoneId || !formInput.wardCode || !formInput.wardName || !formInput.circleId) {
      //   toast.error("Please fill out all required fields");
      //   return;
      // }
      console.log(formInput, "formInput");
      
      if (!formInput.zoneId  || !formInput.wardName || !formInput.circleId) {
        // Display error messages next to the fields
        if (!formInput.zoneId) {
          document.getElementById('zoneIdError').innerText = 'Zone is Required';
        }
        // if (!formInput.wardCode) {
        //   document.getElementById('wardCodeError').innerText = 'ward code is Required.';
        // }
        if (!formInput.wardName) {
          document.getElementById('wardNameError').innerText = 'ward is Required.';
        }
        if (!formInput.circleId) {
          document.getElementById('circleIdError').innerText = 'Circle is Required.';
        }
        return;
      }

      const isDuplicateCode = wards.some(
        (type) =>
          type.wardCode === formInput.wardCode &&
          type.wardName !== editWardData?.wardName && // Exclude the current edited vehicle capacity if any
          type.circleId !== editWardData?.circleId &&
          type.zoneId !== editWardData?.zoneId
      );

      if (isDuplicateCode) {
        // If duplicate code found, show error toast and return
        toast.error("Ward Code already exists. Please choose a different one.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
        return;
      }
      const {
        wardId,
        wardName,
        wardCode,
        circleId,
        zoneId,
        isActive,
      } = formInput;
      const updatedWardData = {
        wardId,
        wardName,
        wardCode,
        circleId,
        zoneId,
        isActive,
      }
      // const isActive = formInput.isActive === "true";
      if (editWardData) {
        // If editing existing ward, update its details
        // const updatedWardData = {
        //   wardId: editWardData.wardId,
        //   wardName: formInput.wardName,
        //   wardCode: formInput.wardCode,
        //   circleId: formInput.circleId,
        //   zoneId: formInput.zoneId,
        //   isActive: formInput.isActive
        // };
        const response = await UpdateWardDetails(updatedWardData);
        setWards([...wards, response]);
        toast.success("Ward updated Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchWardData();
        handleClose();
      } else {
        // If creating new ward, send the formInput to the API
        // const wardData = {
        //   circleId,
        //   wardName: wardName.replace(/\s*\[.*?\]\s*$/, ''),
        //   wardCode,
        //   isActive:isActive, // Use isActive directly from formInput
        // };
        const response = await CreateWardDeatails({
          ...formInput,
          isActive: isActive,
        });
        setWards([...wards, response]);
        toast.success("Ward added Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchWardData();
        handleClose();
      }
      reset();
      // Refresh ward data after successful creation/update

    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 400) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const resetFields = (reset) => {
    setFormInput({
      zoneId: "",
      circleId: "",
      wardId: "",
      isActive: "",
    });
    resetRef.current();
  };

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
    setFormInput({
      // zoneId: "",
      wardId: "",
      wardName: "",
      wardCode: "",
      isActive: true,
      circleId: "",
    });
    setEditWardData(null);
  };

  const handleEditWard = async (selectedWardData) => {
    // Remove the ward code from the wardName
    // const wardNameWithoutCode = selectedWardData.wardName.replace(/\s*\[.*?\]\s*$/, '');
    // console.log(wardNameWithoutCode,'wardddwithoutcode')
    // Set edit ward data and ward ID
    selectedWardData.wardName = selectedWardData.wardName.replace(/\s*\[[^\]]*]/, '');
    setEditWardData(selectedWardData);
    setEditWardId(selectedWardData.wardId);

    // Set form input state with received data, excluding the ward code
    setFormInput({
      // zoneId: selectedWardData.zoneId,
      circleId: selectedWardData.circleId,
      wardId: selectedWardData.wardId,
      wardName: selectedWardData.wardName,
      wardCode: selectedWardData.wardCode,
      isActive: selectedWardData.isActive,
    });

    // Show the modal
    setLgShow(true);
    setIsOptionsLoading(true);

    // Fetch circles data based on zoneId
    try {
      const circlesData = await GetCirclebyID(selectedWardData.zoneId);
      console.log(circlesData)
      setAllCircles(circlesData);
    } catch (error) {
      console.error('Error fetching circles data:', error);
    } finally {
      reset();
      setIsOptionsLoading(false);
    }
  };

  const fetchCirclesData = async (zoneId) => {
    try {
      setLoadingCircles(true);
      const response = await GetCirclebyID(zoneId);
      setCircles(response);
      setAllCircles(response)
      setLoadingCircles(false);
      setCircleFetchError(null); // Clear error if successful
    } catch (error) {
      console.error("Error fetching circles data:", error);
      setCircles([]); // Clear circles data on error
      setLoadingCircles(false);
      setCircleFetchError(
        error.response ? error.response.data.message : "Unknown error occurred"
      ); // Set error message from the backend or use a default message
      toast.error(`Error fetching circles: ${circleFetchError}`);
    }
  };

  const handleZoneChange = async (zoneId) => {
    setFormInput((prevData) => ({
      ...prevData,
      zoneId: zoneId,
      circleId: "", // Reset circle ID when zone changes
    }));
    setSelectedCircle(""); // Clear selected circle
    if (zoneId) {
      fetchCirclesData(zoneId); // Fetch circles data for the selected zone
    } else {
      // If no zone is selected, clear circles dropdown
      setCircles([]);
    }
  };

  // const fetchCirclesAndWards = async (zoneId) => {
  //   try {
  //     const circlesData = await GetCirclebyID(zoneId);
  //     setAllCircles(circlesData);
  //     setSelectedCircle([]);
  //     setCircleFetchError(null);
  //     setNoCircles(false);
  //   } catch (error) {
  //     console.error("Error fetching circles data:", error);
  //     setCircleFetchError("Error fetching circles data");
  //     setAllCircles([]);
  //     setNoCircles(false);
  //   }
  // };

  const fetchAllDataDetails = async () => {
    try {
      const zonesData = await GetZone();
      setAllZones(zonesData);
      if (selectedZone) {
        const circlesData = await GetCirclebyID(selectedZone);
        setAllCircles(circlesData);
        setSelectedCircle([]);
        setIsOptionsLoading(false);
      } else {
        setAllCircles([]);
        setSelectedCircle([]);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  const handleCircleChange = async (circleId) => {
    setFormInput((prevData) => ({
      ...prevData,
      circleId: circleId,
      // ward_id: "", // Reset ward when circle changes
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const alphabetsOnlyRegex = /^[a-zA-Z\s- 0-9]*$/;
    // Check if the input value contains only alphabets and spaces
    if (value === '' || alphabetsOnlyRegex.test(value)) {
      // If the input value is valid, update the state
      setFormInput({ ...formInput, [name]: value });
    }
  };

  const handleCodeChange = (e) => {
    const { name, value } = e.target;
    const alphanumericRegex = /[^a-zA-Z0-9\s]/g;
    const sanitizedValue = value.replace(alphanumericRegex, '');
    setFormInput({ ...formInput, [name]: sanitizedValue });
  }

  // const handleStatusChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormInput((prevData) => ({
  //     ...prevData,
  //     [name]: value === "true" ? true : false,
  //   }));
  // };

  const handleViewWardData = async (id) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsOptionsLoading(true);
      const response = await getWardById(id);
      const wardDetails = response.data.data[0];
      navigate("/ward-details", { state: { wardDetails } });
    } catch (error) {
      //console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  // const downloadAsExcel = () => {
  //   // Add serial number to each item in the collection details
  //   const dataWithSerialNumber = wards.map((item, index) => ({
  //     ...item,
  //     's.no': index + 1,
  //   }));

  //   // Filter out only the data corresponding to the headers displayed in the table component
  //   const filteredData = dataWithSerialNumber.map(item => ({
  //     's.no': item['s.no'],
  //     zone: item.zone,
  //     circle: item.circle,
  //     ward: item.ward,
  //     wardCode: item.wardCode,
  //     status: item.status,
  //   }));

  //   const ws = XLSX.utils.json_to_sheet(filteredData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "OrganizationWard");
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = URL.createObjectURL(data);
  //   downloadLink.download = "OrganizationWard.xlsx";
  //   downloadLink.click();
  // };

  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...wards].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Ward Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Wards");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 6); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 6; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Ward Details", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 6); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Ward Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 6; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // const boldFont = { bold: true };


    // worksheet.addRow(["", "", downloadDateTime, "", ""]);
    // worksheet.mergeCells(1, 3, 1, 7); // Merge cells for downloadDateTime
    // for (let col = 3; col <= 7; col++) {
    //   worksheet.getCell(1, col).font = boldFont; // Set styles individually
    //   worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    // }
    // worksheet.addRow(["", "", "Ward Details", "", ""]);
    // worksheet.mergeCells(2, 3, 2, 6); // Merge cells for cumulativeHeadingReport
    // for (let col = 3; col <= 6; col++) {
    //   worksheet.getCell(2, col).font = boldFont; // Set styles individually
    //   worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    // }

    // worksheet.addRow(["", "", "", "", downloadDateTime, "", "", "", ""]);
    // worksheet.mergeCells(2, 5, 2, 8); // Merge cells for downloadDateTime
    // for (let col = 5; col <= 8; col++) {
    //   worksheet.getCell(2, col).font = boldFont; // Set styles individually
    //   worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    // }

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Ward",
      "Ward Code",
      "Status",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left", color: "#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 6) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" } // White text color
        };
      }
    });

    // Add data rows
    dataToUse.forEach((item, index) => {

      worksheet
        .addRow([
          index + 1,
          item.zone,
          item.circle,
          item.ward,
          item.wardCode,
          item.isActive ? 'Active' : 'InActive',

        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 6) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Add total row with bold font


    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 40 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "WardDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  const searchWardHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalWardData.filter(item => item?.wardName?.toLowerCase()?.includes(term) || item?.wardCode?.toLowerCase()?.includes(term));
    setWards(data);
  }
  return (
    <>
      {/* <div>
        <Body/> */}
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>{t("wardDetails")}</span>
            </div>
            <div className="page-header">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Ward or Ward Code"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchWardHandler}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="flex_end_middle mb-3">
                    {/* {canWriteValue === true ? */}
                      <button className="button-container" onClick={handleShow}>
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        {t("addWard")}
                      </button>
                      {/* : ''} */}
                    <button className="btn btn-excel"
                      onClick={handleSortAndExport}>
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <TableComponent isLoading={isOptionsLoading}
                    DataFetchURL={wards}
                    headers={headers}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 2
                      )
                    }
                    editData={handleEditWard}
                    EditWardData={editWardData}
                    viewData={(id) => handleViewWardData(id)}
                    onSort={handleSort}
                    statusBadge
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editWardData ? t("editWard") : t("addWard")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateWard}>
            <div className="row">
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Select Zone
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.zoneId}
                    name="zoneId"
                    className={`form-select ${formInput.zoneId || !formSubmitted ? "" : "input-error"
                      }`}

                    onChange={(e) => handleZoneChange(e.target.value)}
                    // disabled={!canWriteValue}
                  //  disabled={!formInput.zoneId}
                  >
                    <option value="">Select</option>
                    {zones?.map((zone) => (
                      <option
                        key={zone.zoneId}
                        value={zone.zoneId}
                      >
                        {zone.zoneName}
                      </option>
                    ))}
                  </select>
                  {!formInput.zoneId && formSubmitted && (
                    <div className="required-message">
                      Zone is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Select Circle
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${formInput.circleId || !formSubmitted ? "" : "input-error"
                      }`}
                    name="circleId"
                    value={formInput.circleId}
                    // onChange={(e) => handleCircleChange(e.target.value)}
                    disabled={!canWriteValue}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        circleId: e.target.value,
                      }));
                      handleCircleChange(e.target.value);
                    }}
                  //disabled={!formInput.circleId}
                  >
                    <option value="">Select</option>
                    {/* {loadingCircles && <option>Loading circles...</option>}
                    {circles?.map((circle) => (
    <option key={circle.circleId} value={circle.circleId}>
    {circle.circleName.split(" [")[0]}
    </option>
  ))
 
  } */}
                    {formInput.zoneId ? (
                      loadingCircles ? (
                        <option>Loading circles...</option>
                      ) : allCircles.length > 0 ? (
                        allCircles.filter(circle => circle.zoneId )
                        .map((circle) => (
                          <option key={circle.circleId} value={circle.circleId}>
                            {circle.circleName.split(" [")[0]}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>
                          No circles found
                        </option>
                      )
                    ) : null}
                  </select>
                  {!formInput.circleId && formSubmitted && (
                    <div className="required-message">
                      Circle is Required
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label"> Ward Code <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    className={`form-control ${formInput.wardCode || !formSubmitted ? "" : "input-error"
                      }`}
                    name="wardCode"
                    value={formInput.wardCode}
                    placeholder="Enter Ward code"
                    onInput={handleCodeChange}
                    maxLength={8}
                    disabled={!canWriteValue}
                  />
                  {!formInput.wardCode && formSubmitted && (
                    <div className="required-message">
                      Ward code is Required.
                    </div>
                  )}
                </div>
              </div> */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Ward
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${formInput.wardName || !formSubmitted ? "" : "input-error"
                      }`}
                    name="wardName"
                    value={formInput.wardName}
                    placeholder="Enter Ward"
                    // placeholder={formInput.wardName.split(" [")[0]}
                    onChange={handleInputChange}
                    maxLength={42}
                    // disabled={!canWriteValue}
                  />
                  {!formInput.wardName && formSubmitted && (
                    <div className="required-message">
                      Ward is Required
                    </div>
                  )}
                </div>
              </div>

            </div>
            {/* {editWardData && ( */}
            <div className="col-md-4">
              <label className="form-label">Status<span style={{ color: '#EC1117' }}> *</span></label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="activeRadio"
                    value="true"
                    // checked={formInput.isActive === true}
                    // onChange={handleStatusChange}
                    checked={formInput.isActive} // Check if isActive is true
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: true }, // Set value to true
                      })
                    }
                    color="#EC1117"
                  />
                  <label className="form-check-label" htmlFor="activeRadio">
                    Active
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "60px" }}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="inactiveRadio"
                    value="false"
                    // checked={formInput.isActive === false}
                    // onChange={handleStatusChange}
                    checked={formInput.isActive === false}
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: false }, // Set value to false
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="inactiveRadio">
                    InActive
                  </label>
                </div>
              </div>
            </div>
            {/* )} */}
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ?
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {editWardData ? t("Update") : t("Save")}
                </button>
                : ''}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(OrganizationWard);